import React, { FC, useRef } from 'react';
import styled from 'styled-components';
import { BoxV2, EmptyStateV2 } from '@cubeyou-team/hx-react-components';
import uniqid from 'uniqid';
import MultipleStackedChart from '../MultipleStackedChart';

const StyledMultipleDoubleChartWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #ffffff;
  padding: 10px;
`;

type MultipleDoubleChartProps = {
  margin: any;
  data: any[];
  x1Axis: string;
  x2Axis: string;
  zAxis: string;
  emptyDataMessage: string;
  limit: any;
  showItemsPreview?: boolean;
  colors: any;
  limitText?: number;
  textWidth?: number;
};

const defaultMargin = {
  left: { top: 50, right: 50, bottom: 50, left: 100 },
  right: { top: 50, right: 50, bottom: 50, left: 20 }
};
const MultipleDoubleChart: FC<MultipleDoubleChartProps> = ({
  margin = defaultMargin,
  data,
  x1Axis,
  x2Axis,
  zAxis,
  emptyDataMessage,
  limit = 'auto',
  showItemsPreview,
  colors,
  limitText,
  textWidth
}) => {
  const chartId = useRef(uniqid());
  const isEmpty = !data || data.length === 0;

  if (isEmpty) {
    return (
      <StyledMultipleDoubleChartWrapper>
        <BoxV2 minWidth='100%'>
          <EmptyStateV2
            icon='analytics'
            mainText={emptyDataMessage}
            size='large'
          />
        </BoxV2>
      </StyledMultipleDoubleChartWrapper>
    );
  }

  return (
    <StyledMultipleDoubleChartWrapper>
      <div style={{ width: '50%', height: '100%' }}>
        <MultipleStackedChart
          key={`stacked-bar-left-${chartId.current}`}
          limit={limit}
          xAxis={x1Axis}
          data={data}
          margin={margin.left}
          showAxisLeft
          showItemsPreview={showItemsPreview}
          colors={colors}
          limitText={limitText}
          zAxis={zAxis}
          textWidth={textWidth}
        />
      </div>
      <div style={{ width: '50%', height: '100%' }}>
        <MultipleStackedChart
          key={`stacked-bar-right-${chartId.current}`}
          limit={limit}
          xAxis={x2Axis}
          data={data}
          margin={margin.right}
          showAxisLeft={false}
          showItemsPreview={showItemsPreview}
          colors={colors}
          limitText={limitText}
          zAxis={zAxis}
          textWidth={textWidth}
        />
      </div>
    </StyledMultipleDoubleChartWrapper>
  );
};
export default MultipleDoubleChart;
